import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import {
  ADD_TOAST,
  DELETE_TOAST,
  GET_TOASTS,
  INITIALIZE,
  ToastState,
  SET_TOASTS
} from './types'
import { addToast, initialize, deleteToast } from './actions'

export default async (): Promise<Module<ToastState, {}>> => {
  const { INITIAL_STATE } = await import('./init')
  const { setToasts } = await import('./mutations')
  const { getToasts } = await import('./getter')

  const mutations: MutationTree<ToastState> = {
    [SET_TOASTS]: setToasts
  }

  const actions: ActionTree<ToastState, {}> = {
    [ADD_TOAST]: addToast,
    [DELETE_TOAST]: deleteToast,
    [INITIALIZE]: initialize
  }

  const getters: GetterTree<ToastState, {}> = {
    [GET_TOASTS]: getToasts
  }

  return {
    namespaced: true,
    state: INITIAL_STATE(),
    mutations,
    getters,
    actions
  }
}
